import React from "react";
import Layout from "../components/Layout";
import Adminnav from "../components/Adminnav";

const Adminusers = () => {
  return (
    <Layout>
      <Adminnav adminUsers="active" />
      <div className="admin_container">
        <h4>Users</h4>
        <p>Feature will be added soon....</p>
      </div>
    </Layout>
  );
};

export default Adminusers;
